import { useLazyQuery } from "@apollo/client";
import { INVOICE_LIST } from "./invoice-view.query";
import { IInvoiceListResponse } from "./invoice-view.interface";
import { useEffect, useState } from "react";

export const useInvoice = () => {
  const [loadingDelay, setLoadingDelay] = useState<boolean>(false);
  const [getInvoiceList, { data, loading }] = useLazyQuery<{ getInvoiceList: IInvoiceListResponse }>(INVOICE_LIST, {
    fetchPolicy: "cache-and-network",
  });


  useEffect(() => {
    getInvoiceList();
    setLoadingDelay(true);
    setTimeout(() => {
      getInvoiceList();
      setLoadingDelay(false);
    }, 4500);
  }, []);


  return {
    loading: loading || loadingDelay,
    invoiceList: data?.getInvoiceList,
  };
};
